import { render } from "./AboutChoose.vue?vue&type=template&id=b73faa02&scoped=true"
import script from "./AboutChoose.vue?vue&type=script&lang=js"
export * from "./AboutChoose.vue?vue&type=script&lang=js"

import "./AboutChoose.vue?vue&type=style&index=0&id=b73faa02&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b73faa02"]])

export default __exports__